module.exports = __webpack_public_path__ + "img/wechatpay.aace26c1.svg";